function pickQuestionGalleryUrl(question) {
  const gallery = Array.isArray(question?.questionImageGallery)
    ? question.questionImageGallery
    : [];

  const questionImage = gallery.find((item) => {
    const type = String(item?.type || "").toLowerCase();
    return type === "question" && typeof item?.url === "string";
  });

  return questionImage?.url || "";
}

function isDisplayableUrl(value) {
  if (typeof value !== "string") return false;
  const normalized = value.trim().toLowerCase();
  if (!normalized) return false;

  return (
    normalized.startsWith("http://") ||
    normalized.startsWith("https://") ||
    normalized.startsWith("//") ||
    normalized.startsWith("data:") ||
    normalized.startsWith("blob:") ||
    normalized.startsWith("/")
  );
}

export function resolveQuestionBackgroundUrl(question) {
  const candidates = [
    question?.gameBackgroundImage?.url,
    question?.gameBackgroundImageUrl,
    pickQuestionGalleryUrl(question),
    question?.images?.[0]?.url,
    question?.gameBackgroundImage?.key,
    question?.gameBackgroundImageKey,
  ];

  for (const candidate of candidates) {
    const value = typeof candidate === "string" ? candidate.trim() : "";
    if (!value) continue;
    if (isDisplayableUrl(value)) return value;
  }

  return "";
}
